import { Component } from '@angular/core';
import { PhConfigLoaderService } from '../common/ph-config-loader';

@Component({
    selector: 'app-root',
    template: `
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  `,
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

  constructor(
    private config: PhConfigLoaderService,
  ) {
  }
}
